import React from "react";
import { Route, Routes } from "react-router";
import PasswordRecoveryPage from "./PasswordRecoveryPage";
import PasswordResetPage from "./PasswordResetPage";

const PasswordShell: React.FC = (): React.ReactElement => {
  return (
    <Routes>
      <Route
        path="/reset/:customerUserId/:passwordResetGuid"
        element={<PasswordResetPage />}
      />
      <Route index element={<PasswordRecoveryPage />} />
    </Routes>
  );
};

export default PasswordShell;
